import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getDefaultBaseSettingsConfigFormly,
  generateGenericLabelValueSettingsContentConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { defaultMultiCheckboxConfigFormModel } from '../multicheckbox-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class MultiCheckboxFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultMultiCheckboxConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      generateGenericLabelValueSettingsContentConfig('Checkbox Options'),
    ];
  }
}
